import * as React from "react";
import { AuthContext } from "app/services/auth/ContextProvider";
import { resolveInject } from "app/di";
import { IAppConfigProvider } from "app/services/config/app-config-loader.service";
import { login } from "app/services/backend.service";
import { useTheme } from "app/theme-context";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import { NavigateService } from "app/services/navigate.service";
import { Encoding } from "app/utils/encoding";

export const LoginPage = () => {
    const appConfig = resolveInject(IAppConfigProvider).config;
    const { cssProperties } = useTheme();
    const [email, setEmail] = React.useState<string>();
    const [password, setPassword] = React.useState<string>();
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const { setUser } = React.useContext(AuthContext);
    const backendUrl = appConfig.dataServiceOptions.backendUrl;

    const onLogin = async () => {
        if (!email || !password) {
            return;
        }

        try {
            const loginResponse = await login(email, password);
            if (loginResponse && loginResponse.status == 200) {
                setUser(loginResponse.data);
            }
        } catch (err) {
            if (
                typeof err === "object" &&
                err !== null &&
                "response" in err &&
                typeof (err as any).response === "object" &&
                (err as any).response !== null &&
                "status" in (err as any).response &&
                (err as any).response.status === 401
            ) {
                setErrorMessage("Invalid credentials. Please try again.");
            } else {
                setErrorMessage(
                    "An error has occured. Please try again or contact an administrator"
                );
            }
        }
    };

    return (
        <div style={{ width: "100vw", height: "100vh" }}>
            <section className="vh-100 gradient-custom">
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div
                            className="col-12 col-md-8 col-lg-6 col-xl-5"
                            style={{
                                backgroundColor: "rgb(12, 12, 38)",
                                borderRadius: 16,
                                boxShadow: "0px 0px 32px black",
                                ...cssProperties
                            }}
                        >
                            <div className="text-white" style={{ borderRadius: "1rem" }}>
                                <div className="px-4 text-center">
                                    <form onSubmit={onLogin}>
                                        <div className="mb-md-5 mt-md-4">
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    gap: 14,
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div className="ex-app-logo" />
                                                <h3 style={{ margin: 0, marginBottom: "2em" }}>
                                                    Linked Data Viewer
                                                </h3>
                                            </div>
                                            {appConfig.signIn?.options &&
                                                appConfig.signIn.options.includes(
                                                    "oauth2_microsoft"
                                                ) && (
                                                    <div className="mb-4">
                                                        <a
                                                            href={
                                                                backendUrl +
                                                                "/auth/idprovider?idprovider=microsoft&redirect_uri_client=" +
                                                                Encoding.encodeHash(
                                                                    encodeURI(
                                                                        NavigateService.getAbsoluteURL(
                                                                            "/auth/callback"
                                                                        )
                                                                    )
                                                                )
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    "static/images/ms-symbollockup_signin_" +
                                                                    (appConfig.signIn?.style
                                                                        ?.oauth2_microsoft ??
                                                                        "dark") +
                                                                    ".svg"
                                                                }
                                                                alt="Sign in with Microsoft"
                                                            />
                                                        </a>
                                                    </div>
                                                )}
                                            {appConfig.signIn?.options &&
                                                appConfig.signIn.options.length > 1 && (
                                                    <span className="ex-or-separator text-white-70">
                                                        OR
                                                    </span>
                                                )}
                                            {(!appConfig.signIn?.options ||
                                                appConfig.signIn?.options?.includes("basic")) && (
                                                <>
                                                    <div className="form-outline form-white mb-4 text-left">
                                                        <input
                                                            id="formEmail"
                                                            placeholder="User account"
                                                            className="form-control"
                                                            value={email || ""}
                                                            required
                                                            onChange={(e) =>
                                                                setEmail(e.target.value)
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-outline mb-4 text-left">
                                                        <input
                                                            type="password"
                                                            placeholder="Password"
                                                            id="formPassword"
                                                            className="form-control"
                                                            value={password || ""}
                                                            required
                                                            onChange={(e) =>
                                                                setPassword(e.target.value)
                                                            }
                                                        />
                                                    </div>
                                                    {errorMessage && (
                                                        <p className="text-danger">
                                                            {errorMessage}
                                                        </p>
                                                    )}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            flexDirection: "column",
                                                            gap: "16px"
                                                        }}
                                                    >
                                                        <button
                                                            className="btn btn-outline-light px-5"
                                                            type="submit"
                                                        >
                                                            Sign in
                                                        </button>
                                                        {appConfig.signUpTooltip && (
                                                            <Tooltip
                                                                title={appConfig.signUpTooltip}
                                                                placement="right"
                                                                enterDelay={200}
                                                            >
                                                                <span
                                                                    className="px-1"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "4px"
                                                                    }}
                                                                >
                                                                    <InfoIcon />
                                                                    Sign up
                                                                </span>
                                                            </Tooltip>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
